import React from 'react';
import { authToken, teladocApi } from '@td/api';

class TpnCollection extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      tpns: undefined
    }
  }

  componentDidMount(){
    teladocApi.get('/ref_tpns', {}, authToken.get()).then( (resp) => {
      if(resp.status === 200){
        this.setState({tpns: resp.data.data});
      }
    });
  }

  render(){
    if(this.state.tpns){
      return this.props.children(this.state.tpns);
    }else{
      return null;
    }
  }
}

export default TpnCollection;
